export enum ApiRoute {
    Mail = '/api/mail',
}
